(ns material-ui.core
  (:refer-clojure :exclude [List])
  (:require
    ["@material-ui/core/Typography" :default MUITypography]

    ["@material-ui/core/Grid" :default MUIGrid]

    ["@material-ui/core/Button" :default MUIButton]
    ["@material-ui/core/ButtonGroup" :default MUIButtonGroup]
    ["@material-ui/core/Fab" :default MUIFab]

    ["@material-ui/core/MenuList" :default MUIMenuList]
    ["@material-ui/core/Menu" :default MUIMenu]
    ["@material-ui/core/MenuItem" :default MUIMenuItem]

    ["@material-ui/lab/ToggleButton" :default MUIToggleButton]
    ["@material-ui/lab/ToggleButtonGroup" :default MUIToggleButtonGroup]

    ["@material-ui/core/Avatar" :default MUIAvatar]

    ["@material-ui/core/FormControl" :default MUIFormControl]
    ["@material-ui/core/FormLabel" :default MUIFormLabel]
    ["@material-ui/core/FormControlLabel" :default MUIFormControlLabel]
    ["@material-ui/core/RadioGroup" :default MUIRadioGroup]
    ["@material-ui/core/Radio" :default MUIRadio]
    ["@material-ui/core/Checkbox" :default MUICheckbox]
    ["@material-ui/core/FormGroup" :default MUIFormGroup]
    ["@material-ui/core/Switch" :default MUISwitch]
    ["@material-ui/core/Select" :default MUISelect]
    ["@material-ui/core/Slider" :default MUISlider]

    ["@material-ui/core/List" :default MUIList]
    ["@material-ui/core/ListSubheader" :default MUIListSubheader]
    ["@material-ui/core/ListItem" :default MUIListItem]
    ["@material-ui/core/ListItemText" :default MUIListItemText]
    ["@material-ui/core/ListItemSecondaryAction" :default MUIListItemSecondaryAction]

    ["@material-ui/core/InputBase" :default MUIInputBase]
    ["@material-ui/core/InputAdornment" :default MUIInputAdornment]
    ["@material-ui/core/TextField" :default MUITextField]
    ["@material-ui/core/InputLabel" :default MUIInputLabel]

    ["@material-ui/core/AppBar" :default MUIAppBar]
    ["@material-ui/core/Tabs" :default MUITabs]
    ["@material-ui/core/Tab" :default MUITab]
    ["@material-ui/core/Toolbar" :default MUIToolbar]
    ["@material-ui/core/IconButton" :default MUIIconButton]

    ["@material-ui/icons/Menu" :default MUIMenuIcon]
    ["@material-ui/icons/ArrowBack" :default MUIArrowBackIcon]
    ["@material-ui/icons/ArrowForward" :default MUIArrowForwardIcon]
    ["@material-ui/icons/ArrowDownward" :default MUIArrowDownwardIcon]
    ["@material-ui/icons/ArrowUpward" :default MUIArrowUpwardIcon]
    ["@material-ui/icons/MoreVert" :default MUIMoreVertIcon]
    ["@material-ui/icons/Search" :default MUISearchIcon]
    ["@material-ui/icons/Clear" :default MUIClearIcon]
    ["@material-ui/icons/FilterList" :default MUIFilterListIcon]
    ["@material-ui/icons/ArrowDropDown" :default MUIArrowDropDownIcon]
    ["@material-ui/icons/ExpandMore" :default MUIExpandMoreIcon]
    ["@material-ui/icons/ExpandLess" :default MUIExpandLessIcon]
    ["@material-ui/icons/Add" :default MUIAddIcon]
    ["@material-ui/icons/PersonAdd" :default MUIPersonAddIcon]
    ["@material-ui/icons/ChevronRight" :default MUIChevronRightIcon]
    ["@material-ui/icons/ChevronLeft" :default MUIChevronLeftIcon]
    ["@material-ui/icons/OpenInNew" :default MUIOpenInNewIcon]
    ["@material-ui/icons/Check" :default MUICheckIcon]
    ["@material-ui/icons/FilterCenterFocus" :default MUIFilterCenterFocus]
    ["@material-ui/icons/FormatShapes" :default MUIFormatShapesIcon]
    ["@material-ui/icons/DeleteOutline" :default MUIDeleteOutlineIcon]
    ["@material-ui/icons/Edit" :default MUIEditIcon]
    ["@material-ui/icons/EditOutlined" :default MUIEditOutlinedIcon]
    ["@material-ui/icons/Close" :default MUICloseIcon]
    ["@material-ui/icons/Help" :default MUIHelpIcon]
    ["@material-ui/icons/HelpOutline" :default MUIHelpOutlineIcon]
    ["@material-ui/icons/ZoomIn" :default MUIZoomInIcon]
    ["@material-ui/icons/ZoomOut" :default MUIZoomOutIcon]
    ["@material-ui/icons/SaveAlt" :default MUISaveAltIcon]
    ["@material-ui/icons/Person" :default MUIPersonIcon]
    ["@material-ui/icons/Business" :default MUIBusinessIcon]
    ["@material-ui/icons/Work" :default MUIWorkIcon]
    ["@material-ui/icons/PhoneInTalk" :default MUIPhoneInTalkIcon]
    ["@material-ui/icons/Settings" :default MUISettingsIcon]
    ["@material-ui/icons/Code" :default MUICodeIcon]
    ["@material-ui/icons/Info" :default MUIInfoIcon]
    ["@material-ui/icons/ErrorOutlineOutlined" :default MUIErrorOutlineOutlined]
    ["@material-ui/icons/Today" :default MUITodayIcon]
    ["@material-ui/icons/SwapHoriz" :default MUISwapHorizIcon]
    ["@material-ui/icons/CallSplit" :default MUICallSplit]
    ["@material-ui/icons/Category" :default MUICategoryIcon]
    ["@material-ui/icons/HowToReg" :default MUIHowToRegIcon]
    ["@material-ui/icons/Gesture" :default MUIGestureIcon]
    ["@material-ui/icons/Undo" :default MUIUndoIcon]
    ["@material-ui/icons/Redo" :default MUIRedoIcon]
    ["@material-ui/icons/Palette" :default MUIPaletteIcon]
    ["@material-ui/icons/CheckBoxOutlined" :default MUICheckBoxOutlinedIcon]
    ["@material-ui/icons/CheckBoxOutlineBlank" :default MUICheckBoxOutlineBlankIcon]
    ["@material-ui/icons/Fullscreen" :default MUIFullscreenIcon]
    ["@material-ui/icons/FullscreenExit" :default MUIFullscreenExitIcon]

    ["@material-ui/core/Stepper" :default MUIStepper]
    ["@material-ui/core/Step" :default MUIStep]
    ["@material-ui/core/StepLabel" :default MUIStepLabel]
    ["@material-ui/core/StepContent" :default MUIStepContent]

    ["@material-ui/core/Divider" :default MUIDivider]

    ["@material-ui/core/Popper" :default MUIPopper]
    ["@material-ui/core/Popover" :default MUIPopover]
    ["@material-ui/core/Paper" :default MUIPaper]
    ["@material-ui/core/Grow" :default MUIGrow]
    ["@material-ui/core/ClickAwayListener" :default MUIClickAwayListener]

    ["@material-ui/core/CircularProgress" :default MUICircularProgress]
    ["@material-ui/core/LinearProgress" :default MUILinearProgress]

    ["@material-ui/core/Dialog" :default MUIDialog]
    ["@material-ui/core/DialogTitle" :default MUIDialogTitle]
    ["@material-ui/core/DialogActions" :default MUIDialogActions]
    ["@material-ui/core/DialogContent" :default MUIDialogContent]
    ["@material-ui/core/DialogContentText" :default MUIDialogContentText]

    ["@material-ui/core/Chip" :default MUIChip]

    ["@material-ui/core/Tooltip" :default MUITooltip]

    ["@material-ui/core/Drawer" :default MUIDrawer]

    ["@material-ui/core/Table" :default MUITable]
    ["@material-ui/core/TableBody" :default MUITableBody]
    ["@material-ui/core/TableCell" :default MUITableCell]
    ["@material-ui/core/TableContainer" :default MUITableContainer]
    ["@material-ui/core/TableHead" :default MUITableHead]
    ["@material-ui/core/TableRow" :default MUITableRow]
    ["@material-ui/core/TablePagination" :default MUITablePagination]
    ["@material-ui/core/TableSortLabel" :default MUITableSortLabel]

    ["@material-ui/core/Card" :default MUICard]
    ["@material-ui/core/CardActionArea" :default MUICardActionArea]

    ["@material-ui/core/TextareaAutosize" :default MUITextareaAutosize]

    ["@material-ui/icons/DragIndicator" :default MUIDragIndicator]
    ["@material-ui/icons/Error" :default MUIErrorIcon]
    ["@material-ui/icons/Warning" :default MUIWarningIcon]
    ["@material-ui/icons/TrendingUp" :default MUITrendingUpIcon]

    #_["@material-ui/core/colors/blue" :default m/ColorBlue]
    #_["@material-ui/core/colors/orange" :default m/ColorOrange]

    ))


(def Typography MUITypography)

(def Button MUIButton)
(def ButtonGroup MUIButtonGroup)
(def IconButton MUIIconButton)
(def Fab MUIFab)

(def MenuList MUIMenuList)
(def Menu MUIMenu)
(def MenuItem MUIMenuItem)

(def Tooltip MUITooltip)

(def ToggleButton MUIToggleButton)
(def ToggleButtonGroup MUIToggleButtonGroup)

(def Avatar MUIAvatar)

(def FormControl MUIFormControl)
(def FormLabel MUIFormLabel)
(def FormControlLabel MUIFormControlLabel)
(def RadioGroup MUIRadioGroup)
(def Radio MUIRadio)
(def Checkbox MUICheckbox)
(def FormGroup MUIFormGroup)
(def Switch MUISwitch)
(def Select MUISelect)
(def Slider MUISlider)

(def List MUIList)
(def ListSubheader MUIListSubheader)
(def ListItem MUIListItem)
(def ListItemText MUIListItemText)
(def ListItemSecondaryAction MUIListItemSecondaryAction)

(def InputBase MUIInputBase)
(def InputAdornment MUIInputAdornment)
(def TextField MUITextField)
(def InputLabel MUIInputLabel)

(def AppBar MUIAppBar)
(def Tabs MUITabs)
(def Tab MUITab)
(def Toolbar MUIToolbar)

(def MenuIcon MUIMenuIcon)
(def ArrowBackIcon MUIArrowBackIcon)
(def ArrowForwardIcon MUIArrowForwardIcon)
(def ArrowDownwardIcon MUIArrowDownwardIcon)
(def ArrowUpwardIcon MUIArrowUpwardIcon)
(def MoreVertIcon MUIMoreVertIcon)
(def SearchIcon MUISearchIcon)
(def ClearIcon MUIClearIcon)
(def FilterListIcon MUIFilterListIcon)
(def ArrowDropDownIcon MUIArrowDropDownIcon)
(def ExpandMoreIcon MUIExpandMoreIcon)
(def ExpandLessIcon MUIExpandLessIcon)
(def PersonAddIcon MUIPersonAddIcon)
(def AddIcon MUIAddIcon)
(def ChevronRightIcon MUIChevronRightIcon)
(def ChevronLeftIcon MUIChevronLeftIcon)
(def OpenInNewIcon MUIOpenInNewIcon)
(def CheckIcon MUICheckIcon)
(def FilterCenterFocus MUIFilterCenterFocus)
(def FormatShapesIcon MUIFormatShapesIcon)
(def DeleteOutlineIcon MUIDeleteOutlineIcon)
(def EditIcon MUIEditIcon)
(def EditOutlinedIcon MUIEditOutlinedIcon)
(def CloseIcon MUICloseIcon)
(def HelpIcon MUIHelpIcon)
(def HelpOutlineIcon MUIHelpOutlineIcon)
(def ZoomInIcon MUIZoomInIcon)
(def ZoomOutIcon MUIZoomOutIcon)
(def SaveAltIcon MUISaveAltIcon)
(def PersonIcon MUIPersonIcon)
(def BusinessIcon MUIBusinessIcon)
(def WorkIcon MUIWorkIcon)
(def PhoneInTalkIcon MUIPhoneInTalkIcon)
(def SettingsIcon MUISettingsIcon)
(def CodeIcon MUICodeIcon)
(def InfoIcon MUIInfoIcon)
(def ErrorOutlineOutlined MUIErrorOutlineOutlined)
(def TodayIcon MUITodayIcon)
(def SwapHorizIcon MUISwapHorizIcon)
(def CallSplitIcon MUICallSplit)
(def CategoryIcon MUICategoryIcon)
(def HowToRegIcon MUIHowToRegIcon)
(def GestureIcon MUIGestureIcon)
(def UndoIcon MUIUndoIcon)
(def RedoIcon MUIRedoIcon)
(def PaletteIcon MUIPaletteIcon)
(def CheckBoxOutlinedIcon MUICheckBoxOutlinedIcon)
(def CheckBoxOutlineBlank MUICheckBoxOutlineBlankIcon)
(def FullscreenIcon MUIFullscreenIcon)
(def FullscreenExitIcon MUIFullscreenExitIcon)
(def DragIndicatorIcon MUIDragIndicator)
(def ErrorIcon MUIErrorIcon)
(def WarningIcon MUIWarningIcon)
(def TrendingUpIcon MUITrendingUpIcon)

(def Stepper MUIStepper)
(def Step MUIStep)
(def StepLabel MUIStepLabel)
(def StepContent MUIStepContent)

(def Divider MUIDivider)

(def Popper MUIPopper)
(def Popover MUIPopover)
(def Paper MUIPaper)
(def Grow MUIGrow)
(def ClickAwayListener MUIClickAwayListener)

(def CircularProgress MUICircularProgress)
(def LinearProgress MUILinearProgress)

(def Dialog MUIDialog)
(def DialogTitle MUIDialogTitle)
(def DialogActions MUIDialogActions)
(def DialogContent MUIDialogContent)
(def DialogContentText MUIDialogContentText)

(def Chip MUIChip)

(def Grid MUIGrid)

(def Drawer MUIDrawer)


(def Table MUITable)
(def TableBody MUITableBody)
(def TableCell MUITableCell)
(def TableContainer MUITableContainer)
(def TableHead MUITableHead)
(def TableRow MUITableRow)
(def TablePagination MUITablePagination)
(def TableSortLabel MUITableSortLabel)

(def Card MUICard)
(def CardActionArea MUICardActionArea)

(def TextareaAutosize MUITextareaAutosize)
